/*
 * @Descripttion: 图表mixins
 * @Author: zhanghang
 * @Date: 2021-07-27 14:01:59
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-09-25 18:25:52
 */
import graph from "./graph.js";
import { eventTemp } from "_dataview/output/utils/relativeEvent";
import utils from '_dataview/output/utils/gis.js'
export default {
  mixins: [graph],
  props: {
    //加载地图geo名称
    area: {
      type: Object,
      default() {
        return {
          area: "china",
          url: "",
          showName: "",
        };
      },
    },
    isDown: {
      type: Boolean,
      default: true,
    },
    fontColor: {
      type: String,
      default: "#FFFFFF",
    },
    fontSize: {
      type: [String, Number],
      default: "12",
    },
    position: {
      type: Array,
      default: () => [0, 0, "auto", "auto"],
    },
    defaultSeries: {
      type: String,
      default: "0",
    },
    romLength: {
      type: [String, Number],
      default: 10,
    },
    scatterLength: {
      type: [String, Number],
      default: 3,
    },
    //事件依赖
    eventRelativeDeal: {
      type: Object,
      default() {
        return {
          load: {
            relatives: [],
            fn: eventTemp,
          },
          click: {
            relatives: [],
            fn: eventTemp,
          },
          dbclick: {
            relatives: [],
            fn: eventTemp,
          },
          back: {
            relatives: [],
            fn: eventTemp,
          },
        };
      },
    },
    mapName: {
      type: String,
      default: dsf.uuid(32),
    },
    mapButtonGroup: {
      type: Object,
      default: () => ({
        show: false,
        position: "top-right", // 位置
        buttonsSize: 20, // 大小
        buttonsColor: "#999", // 颜色
        buttonsDirection: "column", // 横向排布 row, 纵向排布 column
        borderColor: "#999",
        eidtSize: 0.1,
        buttons: [
          {
            icon: "icon-fangda",
            name: "放大",
          },
          {
            icon: "icon-suoxiao",
            name: "缩小",
          },
          {
            icon: "icon-shuaxin",
            name: "重置",
          },
        ],
      }),
    },
  },
  watch: {
    cycleTime() {
      this.resetCallback();
    },
    area: {
      handler() {
        this.$nextTick(() => {
          this.registerMap().then(this.init);
        });
      },
      deep: true,
    },
  },
  data() {
    return {
      mapjson: {},
      // 图表对象
      chartObj: null,
      timer: null,
      // 组件类型
      componentType: "map",
      clickTimer: null,
      //地图列表
      mapNames: [],
      coordMap: new Map(),
      otherEvents: ["切换地图", "清除地图数据"],
    };
  },
  computed: {
    backStyle() {
      let color = this.fontColor;
      if (color === "theme") {
        color = "@main";
      }
      color = dsf.themeConfig.getThemeColor(color) || color;

      // console.log('color',color)
      let [left, top, right, bottom] = this.position;
      return {
        color,
        left,
        top,
        right,
        bottom,
        fontSize: this.transFontSize,
      };
    },
    showBack() {
      return (this.isDesign && this.isDown) || this.mapNames.length > 1;
    },
    mapButtonGroupAttr() {
      // position
      const {
        position,
        buttonsDirection,
        borderColor,
        buttonsSize,
        buttonsColor,
      } = this.mapButtonGroup;
      this.mapButtonGroup.slotName = "slot-" + position;
      // 样式设置
      this.mapButtonGroup.slotParentStyle = {
        "flex-direction": buttonsDirection,
      };
      this.mapButtonGroup.slotChildStyle = {
        "border-color": borderColor,
      };
      this.mapButtonGroup.slotSpanStyle = {
        fontSize: this.transPX(buttonsSize),
        color: buttonsColor,
      };
      return this.mapButtonGroup;
    },
  },
  created() {
    // chartstring 获取 chartstring 作为chart
    if (this.chartString) {
      let chartString = this.chartString;
      let tmp = `(function () {
        return ${chartString}
      })()`;
      this.$emit("update:chart", eval(tmp));
    }
    let name = this.area.area == "china" ? "china" : this.mapName;

    this.chart.geo.map = name;
    this.chart.series[0].map = name;
  },
  beforeDestroy() {
    this.chartObj && this.chartObj.dispose();
    this.timer && clearInterval(this.timer);
  },
  methods: {
    //地图返回
    backMapFn() {
      if (this.isDesign) return false;
      this.mapNames.pop();
      let o = this.mapNames[this.mapNames.length - 1];
      let mapName = o.value;
      this.chart.geo.map = mapName;
      this.chart.series[0].map = mapName;
      this.reset();
      this.loadbackMapEvents(o);
    },
    //双击依赖组件关联方法
    loaddbClickEvents(data) {
      let { fn } = this.eventRelativeDeal.dbclick;
      this.currentCompentData = data;
      this.handleCommonEmit(fn, data);
    },
    //返回地图
    loadbackMapEvents(data) {
      let { fn } = this.eventRelativeDeal.back;
      this.currentCompentData = data;
      this.handleCommonEmit(fn, data);
    },
    //地图切换
    handleChangeMap(url, mapName, showName) {
      if (!/\//g.test(url)) {
        url = `$/js/libs/echarts/mapCoord/${url}.json`;
      }
      this.loadMap(url, mapName, showName).then(this.reset);
    },
    //删除地图数据
    handleDeleteMapData(name) {
      if (!name) {
        this.chart.series.forEach((item) => {
          item.data = [];
        });
        this.reset();
      }
      let item = this.chart.series.find((it) => it.name == name);
      if (item) {
        item.data = [];
        this.reset();
      }
    },
    //添加点位
    addScatter(data, seriesName, chart = this.chart) {
      let series = chart.series.find((it) => it.name == seriesName);
      if (!series) return false;

      series.data = data.map((it) => {
        let coordMap = this.coordMap;
        // 兼容坐标系
        if (typeof it.value === "string" && it.value.indexOf(",") > -1) {
          return {
            ...it,
            name: it.name,
            visualMap: false,
            value: it.value.split(","),
          };
        } else if (Array.isArray(it.value)) {
          return {
            ...it,
            name: it.name,
            visualMap: false,
            value: it.value,
          };
        }

        return {
          ...it,
          name: it.name,
          visualMap: false,
          value: coordMap.get(it.name)
            ? coordMap.get(it.name).concat(it.value)
            : [],
        };
      });
    },
    //添加热力图
    addHeatMap(data) {
      this.chart.series[0].data = data;
    },

    //添加飞行线
    addFlyLine(data, seriesName, chart = this.chart) {
      let series = chart.series.find((it) => it.name == seriesName);
      if (!series) return false;
      series.data = data.map((it) => {
        let coordMap = this.coordMap;
        let start = coordMap.get(it[0]) ? coordMap.get(it[0]) : [];
        let end = coordMap.get(it[1]) ? coordMap.get(it[1]) : [];
        //兼容坐标系
        if (typeof it[0] == "string" && it[0].indexOf(",") > -1) {
          start = it[0].split(",");
        } else if (Array.isArray(it[0])) {
          start = it[0];
        }
        if (typeof it[1] == "string" && it[1].indexOf(",") > -1) {
          end = it[1].split(",");
        } else if (Array.isArray(it[1])) {
          end = it[1];
        }

        return {
          ...it,
          visualMap: false,
          coords: [start, end],
        };
      });
    },
    beforeInit() {
      this.loadEcharts(this)
        .then(() => {
          this.loadCharts().then(() => {
            this.init();
          });
        })
        .catch((ex) => {
          dsf.error(ex);
        });
    },
    loadCharts() {
      return this.loadEcharts(this)
        .then(() => {
          this.initEacharts();
          //注册地图
          return this.registerMap()
        })
        .catch((ex) => {
          throw ex;
        });
    },

    registerMap(area = this.area) {
      if (area.area === "custom" && !area.url) return;
      let url = "";
      if (area.area != "custom") {
        url = `$/js/libs/echarts/mapCoord/${area.area}.json`;
      } else {
        url = area.url;
      }
      let mapName = this.mapName;
      let showName = this.area.showName;
      if (area.area === "china") {
        mapName = "china";
      }

      return this.loadMap(url, mapName, showName);
    },

    loadMap(url, mapName, showName) {
      return this.dsf.http.get(url, {}).done((mapjson) => {
        this.mapjson = mapjson;
        let echarts = window.$echarts || window.echarts;

        echarts.registerMap(mapName, mapjson);

        this.chart.geo.map = mapName;
        this.chart.series[0].map = mapName;

        //计算中心坐标点
        let features = this.mapjson.features;
        let coordMap = new Map();
        //地理信息点位
        features.forEach((it) => {
          //存在中心点位
          if (it.properties.cp) {
            coordMap.set(it.properties.name, it.properties.cp);
          } else if (it.geometry.type) {
            let type = it.geometry.type;
            let polygons = [];
            if (type == "MultiPolygon") {
              polygons = it.geometry.coordinates[0];
            } else if (type == "Polygon") {
              polygons = it.geometry.coordinates;
            }

            if (Array.isArray(polygons[0]) && polygons.length) {
              polygons = utils.polygon(polygons)
              let re = utils.centroid(polygons)
              coordMap.set(it.properties.name, re.geometry.coordinates);
            }
          }
        });
        this.coordMap = coordMap;

        //放入地图列表
        this.mapNames.push({
          name: showName || mapName,
          value: mapName,
        });
      });
    },
    //事件添加
    resetCallback() {
      let chart = this.chartObj;

      let series = this.chart.series;
      // 数据项目
      let index = this.defaultSeries;

      // 当前索引
      let curInd = 0;
      const len = series[index]?.data ? series[index].data.length : 0;

      let highSeries = [index];
      clearInterval(this.timer);
      if (this.cycleTime > 0 && len) {
        /*建立时间监听器*/
        this.timer = setInterval(function () {
          chart.dispatchAction({
            type: "downplay",
            seriesIndex: highSeries,
          });
          chart.dispatchAction({
            type: "hideTip",
            seriesIndex: highSeries,
          });
          curInd++;
          if (curInd === len) {
            curInd = 0;
          }
          chart.dispatchAction({
            type: "highlight",
            seriesIndex: highSeries,
            dataIndex: curInd,
          });
          chart.dispatchAction({
            type: "showTip",
            seriesIndex: highSeries,
            dataIndex: curInd,
          });
        }, this.cycleTime);
      }
      try {
        chart.off("click");
        chart.off("dblclick");
        chart.off("georoam");
      } catch (error) {
        console.log(error);
      }

      this.loadWordToPinyin(() => {
        chart.on("click", (params) => {
          clearTimeout(this.clickTimer);
          this.clickTimer = setTimeout(() => {
            // echarts 点击事件
            let item = null;
            if (Array.isArray(this.data)) {
              item = this.data.find((it) => it.name === params.name);
            }
            if (item) {
              params = item;
            }
            if (this.$listeners["chart-click"]) {
              this.$dispatch("chart-click", params);
            }

            if (params.name) {
              params.code = pinyinPro
                .pinyin(params.name, { toneType: "none" })
                .split(" ")
                .join("");
            }
            this.loadClickEvents(params);
          }, 500);
        });

        chart.on("dblclick", (params) => {
          clearTimeout(this.clickTimer);
          let item = this.data?.find((it) => it.name === params.name);
          if (item) {
            params = item;
          }
          if (this.$listeners["chart-dblclick"]) {
            this.$dispatch("chart-dblclick", params);
          }

          if (params.name) {
            params.code = pinyinPro
              .pinyin(params.name, { toneType: "none" })
              .split(" ")
              .join("");
          }
          this.loaddbClickEvents(params);
        });
      });

      //geo 同步缩放
      chart.on("georoam", function (params) {
        var option = chart.getOption(); //获得option对象

        if (params.zoom != null && params.zoom != undefined) {
          //捕捉到缩放时
          option.geo[0].zoom = option.series[0].zoom; //下层geo的缩放等级跟着上层的map一起改变
          option.geo[0].center = option.series[0].center; //下层的geo的中心位置随着上层map一起改变
        } else {
          //捕捉到拖曳时
          option.geo[0].center = option.series[0].center; //下层的geo的中心位置随着上层map一起改变
        }
        chart.setOption(option); //设置option
      });
    },
    // 地图按钮点击事件处理
    handlemapButtonGroupClick(idx) {
      if (!this.chartObj) {
        return;
      }
      const option = this.chartObj.getOption(); //获得option对象
      const item = this.mapButtonGroupAttr.buttons[idx];
      const seriesMap = option.series.find((it) => it.type === "map");
      const geoMap = option.geo[0];
      // 不执行地图操作事件
      if (!seriesMap || !geoMap) {
        return;
      }
      const { name } = item;
      // 对zoom值做限定, 最小值不能小于0，最大值不能大于100
      switch (name) {
        case "放大":
          seriesMap.zoom += this.mapButtonGroupAttr.eidtSize;
          geoMap.zoom += this.mapButtonGroupAttr.eidtSize;
          if (geoMap.zoom > 100) {
            seriesMap.zoom = 100;
            geoMap.zoom = 100;
          }
          break;
        case "缩小":
          seriesMap.zoom -= this.mapButtonGroupAttr.eidtSize;
          geoMap.zoom -= this.mapButtonGroupAttr.eidtSize;
          if (geoMap.zoom <= 0) {
            seriesMap.zoom = 0.01;
            geoMap.zoom = 0.01;
          }
          break;
        case "重置":
          seriesMap.zoom = 1.1;
          geoMap.zoom = 1.1;
          break;
      }
      // 重绘地图
      this.chartObj.setOption(option);
    },
    // 汉字转拼音
    loadWordToPinyin(callback) {
      if (window.pinyinPro) {
        callback?.();
      } else {
        this.$http
          .importFiles([dsf.url.getWebPath("$/js/libs/pinyin/pinyin-pro.js")])
          .then(() => {
            callback?.();
          })
          .catch((err) => {
            console.error(err);
            dsf.layer.message("加载Sortable文件报错", false);
          });
      }
    },
  },
};
